import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=505e2dd6&"
import script from "./driver.vue?vue&type=script&lang=js&"
export * from "./driver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports